import classNames from 'classnames';
import React, { memo } from 'react';
import Icon from './Icon';
import { useSelector } from 'react-redux';
import { useVariation } from '@hooks/useVariation';
import ProductShippingVariant from './ProductShippingVariant';

const ProductShipping = ({ freeEconomySubtotal, itemRate, className = '' }) => {
  const isEnhancedPDPVariant = useVariation('Enhanced PDP');

  const stock = useSelector((state: any) => state.pdpItem.details?.stock);
  const shippingInfo = useSelector((state: any) => state.pdpItem.details?.shippingInfo);

  if (isEnhancedPDPVariant)
    return (
      <ProductShippingVariant
        freeEconomySubtotal={freeEconomySubtotal}
        itemRate={itemRate}
        className={className}
      />
    );

  const isPreorder = stock === 'preOrder';

  return (
    <div className={classNames('tw:flex tw:gap-2', className)}>
      <div className='tw:w-[24px] tw:text-center'>
        <Icon url='/assets/images/rtic/nav/truck-icon.svg' size={24} color='var(--brand-black)' />
      </div>
      {!isPreorder && (
        <div>
          <p className='tw:mb-0 tw:text-sm tw:font-bold tw:leading-4 tw:text-brand-black'>Free Shipping</p>
          <p className='tw:mb-0 tw:text-sm tw:font-normal tw:text-gray-dark'>
            {itemRate < freeEconomySubtotal ? `On Orders $${freeEconomySubtotal}+` : 'This item ships free'}
          </p>
        </div>
      )}
      {isPreorder && (
        <div>
          <p className='tw:mb-0 tw:text-sm tw:font-bold tw:leading-4 tw:text-brand-black'>Order Now</p>
          <p className='tw:mb-0 tw:text-sm tw:font-normal tw:text-gray-dark'>
            Expected to ship by <em>{shippingInfo?.shipDateLocalFormatted}</em>
          </p>
        </div>
      )}
    </div>
  );
};

export default memo(ProductShipping);
